// extracted by mini-css-extract-plugin
export default {"container":"QTG0R","name":"Dhhtf"};